import { Button, Result } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface IProps {
  auctionId?: string;
}

const AuctionResult: React.FC<IProps> = ({ auctionId }) => {
  const navigate = useNavigate();

  return (
    <Result
      status='success'
      title='Auction is over!'
      subTitle='Thank you for participating in the auction.'
      extra={[
        <Button
          type='primary'
          key='result'
          onClick={() => navigate(`/auctions/${auctionId ?? ''}`)}
        >
          View Results
        </Button>,
        <Button key='home'>Go Home</Button>,
      ]}
    />
  );
};

export default AuctionResult;
